var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-container',{staticClass:"mc-checkbox-group",attrs:{"title":_vm.title,"tips":_vm.currentTips}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-checkbox-group.vue